
import React from 'react';
import { Link } from 'react-router-dom';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  withText?: boolean;
}

const Logo: React.FC<LogoProps> = ({ size = 'md', withText = true }) => {
  const logoSizes = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-12 h-12'
  };

  const textSizes = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl'
  };

  return (
    <Link to="/" className={`flex items-center gap-2 ${withText ? '' : 'justify-center'}`}>
      <img 
        src="/lovable-uploads/0f99faca-f29d-4e9a-8a7f-b64e3199a5a2.png" 
        alt="Alfa Peixes Logo" 
        className={`${logoSizes[size]} object-contain`}
      />
      {withText && (
        <span className={`font-bold text-navy-600 dark:text-white ${textSizes[size]}`}>
          Alfa Peixes
        </span>
      )}
    </Link>
  );
};

export default Logo;
